import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";

const Movie = () => {
  const [movie, setMovie] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await axios.get(
        `https://backendexample.sanbersy.com/api/data-movie`
      );

      setMovie(
        result.data.map((el) => {
          const {
            id,
            title,
            description,
            year,
            duration,
            genre,
            rating,
            review,
            image_url,
          } = el;
          return {
            id,
            title,
            description,
            year,
            duration,
            genre,
            rating,
            review,
            image_url,
          };
        })
      );
    };
    fetchData();
  }, []);

  return (
    <>
    <h2 style={{textAlign:"left"}}>UpComing Movie</h2>
    {movie !== null && (
    <div style={{ margin: "0 auto", textAlign: "left"}}>
        <div className="conteiner-fluid movie-app">
            {movie.map((el, index)=>{
                return(
                    <div key={index} style={{display:"inline-block", textAlign:"center", padding:"10px 40px", verticalAlign:"top"}}>
                        <Link to={`/movie/detail/${el.id}`}><img src={el.image_url} style={{borderRadius:"10px", height:"360px", width:"240px", objectFit:"cover"}}></img></Link>
                        <div>{el.title}</div>
                        <div>{el.year}</div>
                    </div>
                )
            })}
        </div>
    </div>
    )}
    </>
  );
};

export default Movie;
